var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#505F79",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.287 34.243L2.41 3.864M3.178 6.009s4.224-4.58 11.562-4.58c4.466 0 6.507 2.91 10.193 2.91 3.683 0 7.222-2.91 7.222-2.91v18.916s-2.66 1.456-5.821 1.456c-3.16 0-4.448-1.456-8.73-1.456-4.061 0-7.879 3.942-7.879 3.942L3.178 6.009z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505F79",
    fillRule: "nonzero",
    d: "M3.178 6.009s2.192-2.321 5.15-3.276L10.59 8.54s-2.92 1.05-5.303 3.29L3.253 6.223"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505F79",
    fillRule: "nonzero",
    d: "M10.59 8.539l2.438 6.259s1.917-.682 3.237-.682 2.628.194 2.628.194l-1.77-6.657s-.5-.07-1.117-.07c-2.955 0-5.417.956-5.417.956z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505F79",
    fillRule: "nonzero",
    d: "M7.66 18.42l2.065 5.866s2.857-2.738 5.577-3.509l-2.274-5.98c-2.62 1.01-5.368 3.622-5.368 3.622zM15.49 1.508l1.634 6.144c1.322 0 4.997 1.802 4.997 1.802l-1.449-6.345c-.83-.31-3.007-1.498-5.183-1.6zM18.893 14.309l1.683 6.325c.847 0 3.277 1.035 4.334 1.035l-1.42-6.218c-1.369-.356-3.582-1-4.597-1.142z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505F79",
    fillRule: "nonzero",
    d: "M22.121 9.455l1.369 5.996s1.369.253 2.309.253c.939 0 2.11-.213 2.11-.213l-.445-5.49s-.907.281-2.006.281c-1.716 0-3.337-.827-3.337-.827zM26.984 4.052L27.465 10s2.236-.562 4.691-2.418l-.001-6.153c-2.82 2.16-5.17 2.623-5.17 2.623zM27.91 15.491s2.153-.399 4.245-1.614v6.468c-2.228 1.069-3.76 1.263-3.76 1.263l-.486-6.117z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default ForwardRef;